<div class="boxes fill flex">
  <div class="flex-1 flex--basis0 flex flex--start flex--start flex--self-center">
    <ng-content select="[left]" />
  </div>

  <div class="flex-1 flex flex--center flex--self-center">
    @if (showLink()) {
      <!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -->
      <a [finLink]="homeLink$()" class="dn-laptop-up inherit-color flex" (click)="onHomeClick($event)">
        <span class="is-vishidden">{{ 'actions.home' | finLocalization }}</span>
        <fcom-icon class="emblem" [category]="IconLibrary.CUSTOM" [name]="CustomIcon.FINNAIR_EMBLEM" />
      </a>
    } @else {
      <fcom-icon class="dn-laptop-up emblem" [category]="IconLibrary.CUSTOM" [name]="CustomIcon.FINNAIR_EMBLEM" />
    }

    <ng-content select="[center]" />
  </div>

  <div class="flex-1 flex--basis0 flex flex--end flex--self-center align-right">
    <ng-content select="[right]" />
  </div>
</div>
